import api from '../api';

const cache = new Map();
const pending = new Map();
const queue = [];
const sessions = new WeakMap();
let sessionSequence = 0;
let active = 0;
let cacheBytes = 0;
const MAX_BYTES = 8 * 1024 * 1024;
const TTL = 120000;

export const photoSession = (user) => {
  if (!user || typeof user !== 'object') return 'anonymous';
  if (!sessions.has(user)) sessions.set(user, ++sessionSequence);
  return sessions.get(user);
};
const drain = () => {
  while (active < 3 && queue.length) {
    const task = queue.shift();
    active++;
    task.run().then(task.resolve, task.reject).finally(() => { active--; drain(); });
  }
};

export function loadConsultationPhoto({ scope, id, revision = '', session, isVisible = () => true }) {
  const key = `${session}:${scope}:${id}:${revision}`;
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < TTL) {
    cache.delete(key); cache.set(key, hit);
    return Promise.resolve(hit.value);
  }
  if (pending.has(key)) { const hit = pending.get(key); hit.listeners.add(isVisible); return hit.promise; }
  const listeners = new Set([isVisible]);
  const promise = new Promise((resolve, reject) => {
    queue.push({ resolve, reject, run: async () => {
      // A page change may remove a row before its turn in the request queue.
      if (![...listeners].some((visible) => visible())) return null;
      const route = scope === 'attendees' ? '/attendee-management/attendees' : '/student-management/students';
      const response = await api.get(`${route}/${id}/photo`, { skipGlobalErrorModal: true, skipTransientRetry: true });
      const value = response.data?.photoUrl || null;
      const bytes = (value?.length || 0) * 2;
      if (cache.has(key)) { cacheBytes -= cache.get(key).bytes; cache.delete(key); }
      if (bytes <= MAX_BYTES) {
        cache.set(key, { value, bytes, at: Date.now() }); cacheBytes += bytes;
        while (cache.size > 64 || cacheBytes > MAX_BYTES) {
          const oldest = cache.keys().next().value;
          cacheBytes -= cache.get(oldest).bytes; cache.delete(oldest);
        }
      }
      return value;
    } });
  });
  pending.set(key, { promise, listeners });
  promise.finally(() => pending.delete(key)).catch(() => {});
  drain();
  return promise;
}
